import styled from 'styled-components'

import { color, font } from '~/styles/utils'

export const ProductLine = styled.div`
  ${font('base')};
  line-height: 17px;
  display: flex;
  justify-content: space-between;
`

export const ProductPrice = styled.div`
  font: ${font('demi')};
  margin: auto 0;
  white-space: nowrap;
  width: 90px;
  text-align: right;
`

export const OrderPassInsurance = styled.div`
  display: flex;
  align-content: center;
  font-size: 16px;
  color: ${color('mediumGrey')};
  white-space: nowrap;
`
